var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"row"},_vm._l((_vm.apply),function(chart,i){return _c('div',{key:`chart_${i}`,staticClass:"col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-sm-12 col-xs-12"},[_c(chart.component,_vm._b({ref:chart.component,refInFor:true,tag:"component"},'component',_vm.chartsData[chart.component],false))],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }